<template>
<div>
  <el-row type="flex" class="title-bar" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
    <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad"/>
    <w-header-search-button @click="onClickSetSearchToolVisible"></w-header-search-button>
  </el-row>
  <el-table-wrapper v-loading="isLoading" :data="tableData" :columns="columns" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool">
  </el-table-wrapper>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import floor from 'lodash/floor';
import { convertValuByUnit } from '@/utils/number';
import { analysisTimeType } from '@/constants/performance';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import databaseTableInfoAPI from '@/api/performance/database/database-table-info';
import { columnDefault } from '@/constants/table';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import AnalysisTableMixin from '@/mixins/performance/analysis-table-ex';

export default {
  name: 'WDemonprocessTiberoTable',
  mixins: [AnalysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      isLoading: false,
      checkDatetime: null,
      columnDefault,
      tableData: [],
      showSearchTool: false,
      columns: [
        {
          prop: 'PID',
          label: 'PID',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'NAME',
          label: '프로세스명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'LATCHWAIT',
          label: 'LATCHWAIT(msec)',
          sortable: true,
          formatter: this.convertValue,
        },
        {
          prop: 'PGA_USED_MEM',
          label: 'PGA 사용량(byte)',
          sortable: true,
          formatter: this.convertByteValue,
        },
      ],
    };
  },
  methods: {
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
        baselineDatetime: this.operationFlag ? new Date().getTime() : this.plotLineDatetime,
        managetypeId: 'DBMS',
      };
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        params.queryId = 'DBTBProcessInfo';
        this.isLoading = true;
        databaseTableInfoAPI.getCurrentDemonprocessList(params).then((result) => {
          if (result.data.success === true) {
            this.tableData = result.data.data;
          } else {
            this.failToLoadData();
          }
        }).catch(() => {
          this.failToLoadData();
        }).finally(() => {
          this.isLoading = false;
        });
      } else {
        databaseTableInfoAPI.getDemonprocessTiberoList(params).then((result) => {
          if (result.data.success === true) {
            const snapshotData = result.data.data;
            this.tableData = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          }
        }).catch(() => {
          this.failToLoadData();
        }).finally(() => {
          this.isLoading = false;
        });
      }
    },
    /**
     * 데이터 조회 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadData() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '데몬 프로세스', false));
    },
    /**
     * [테이블 컬럼 포멧]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    convertValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null);
    },
    convertByteValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, 'Byte', false, false, true);
    },
    /**
     * [getPercentage 프로그래스바 * 100]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getPercentage(value) {
      return isNil(value) ? 0 : floor(value, 2);
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    onClickSetSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/table/DemonProcess/DemonprocessTiberoTable.vue